/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function All({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M14.4 8.613V8c0-.807-.343-1.598-.868-2.12-.516-.511-1.166-.733-1.842-.533-1.028.303-1.65.985-3.214 3.02-1.51 1.961-2.359 3.003-3.827 3.437-1.178.348-2.268-.079-3.028-.834A4.25 4.25 0 0 1 .401 8v-.41A3.69 3.69 0 0 1 4.09 3.9c.953 0 1.853.443 2.434 1.199l.268.347a.6.6 0 0 1-.951.733l-.268-.348A1.87 1.87 0 0 0 4.091 5.1 2.49 2.49 0 0 0 1.6 7.59V8c0 .807.343 1.598.868 2.12.516.511 1.166.733 1.842.533 1.028-.303 1.65-.985 3.214-3.02 1.51-1.961 2.359-3.003 3.827-3.437 1.178-.348 2.268.079 3.028.834A4.25 4.25 0 0 1 15.599 8v.613a3.486 3.486 0 0 1-6.248 2.126l-.144-.185a.6.6 0 0 1 .951-.733l.144.187A2.286 2.286 0 0 0 14.4 8.613" /></svg>;
}
;